import React from "react";

// Small inline dot + label for a chosen colour ({name, hex})
export default function ColorSwatch({color}) {
  return (
    <span style={{display: "inline-flex", alignItems: "center", gap: 5, verticalAlign: "middle"}}>
      <span
        style={{
          width: 12,
          height: 12,
          borderRadius: "50%",
          background: color.hex,
          border: "1px solid rgba(0,0,0,0.2)",
          display: "inline-block",
          WebkitPrintColorAdjust: "exact",
          printColorAdjust: "exact",
        }}
      />
      {color.name || color.hex}
    </span>
  );
}
